import * as actions from '../../actions/actionTypes';

const initialState = '';

export default function providerId(state = initialState, action) {
  switch (action.type) {
    case actions.INIT_CURRENT_USER:
      return initialState;
    case actions.SET_CURRENT_USER:
      //if (action.body && typeof action.body.providerId !== 'undefined') {
      return action.body && action.body.providerId !== 'undefined' ? action.body.providerId : '';
    // } else {
    //   return state;
    // }
    default:
      return state;
  }
}
